@if (locked()) {
  <div
    class="screen-lock-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="screen-lock-title"
    (keydown.enter)="unlock()">
    <div class="screen-lock-card flex max-h-[90vh] flex-col overflow-hidden rounded-2xl bg-card shadow-xl dark:bg-zinc-900">
      <div class="dialog-header sticky top-0 z-10 shrink-0 !m-0 !px-6 !py-4 bg-primary text-white shadow-sm">
        <div class="flex items-center gap-3 min-w-0">
          <div class="flex items-center justify-center w-11 h-11 rounded-xl bg-white/15 shrink-0">
            <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
          </div>
          <div class="min-w-0">
            <h2 id="screen-lock-title" class="dialog-title !text-white text-lg font-semibold tracking-tight m-0">
              Screen locked
            </h2>
            <p class="dialog-subtitle !text-white/80 text-sm m-0 mt-0.5 truncate">
              {{ displayName }}
            </p>
          </div>
        </div>
      </div>

      <div class="!m-0 min-h-0 flex-1 overflow-y-auto !px-6 !py-5 min-w-0">
        <p class="text-sm text-secondary mb-4">
          Enter your password to continue. Your work is still open — unlocking does not sign you out.
        </p>

        <form [formGroup]="form" class="flex flex-col gap-3" (ngSubmit)="unlock()">
          <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
            <mat-label>Password</mat-label>
            <input
              #passwordInput
              matInput
              formControlName="password"
              [type]="showPassword() ? 'text' : 'password'"
              autocomplete="current-password" />
            <button
              mat-icon-button
              type="button"
              matSuffix
              tabindex="-1"
              (click)="showPassword.set(!showPassword())"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
              <mat-icon
                class="icon-size-5"
                [svgIcon]="showPassword() ? 'heroicons_solid:eye-slash' : 'heroicons_solid:eye'"></mat-icon>
            </button>
            @if (form.controls.password.touched && form.controls.password.hasError('required')) {
              <mat-error>Password is required</mat-error>
            }
          </mat-form-field>

          @if (errorMessage()) {
            <div class="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 dark:border-red-800/60 dark:bg-red-950/40 dark:text-red-300">
              {{ errorMessage() }}
            </div>
          }
        </form>
      </div>

      <div class="sticky bottom-0 z-10 shrink-0 bg-card px-6 pb-5 pt-2 dark:bg-zinc-900">
        <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <button mat-stroked-button type="button" (click)="signOut()">
            Sign out
          </button>
          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="unlocking() || form.invalid"
            (click)="unlock()">
            @if (unlocking()) {
              <mat-progress-spinner class="me-2" [diameter]="20" mode="indeterminate"></mat-progress-spinner>
            }
            Unlock
          </button>
        </div>
      </div>
    </div>
  </div>
}
